import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as constants from './constants';
import { PourApprovalPageParams } from './constants';
import usePourApprovalPageQueries, { PourApprovalPageQueries } from './usePourApprovalPageQueries';

const PourApprovalPage = lazyWithSuspense(() => import('./PourApprovalPage'));

const page: Page<PourApprovalPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<PourApprovalPageParams, PourApprovalPageQueries>({
    pageDataHook: usePourApprovalPageQueries,
    WrappedPage: PourApprovalPage,
    titleFn: () => i18n._(constants.TITLE),
  }),
};

export default page;
